export default class AjaxError extends Error {
    /**
     * @param {string} message
     * @param {Response} response
     */
    constructor(message, response) {
        super(message)
        this.name = 'AjaxError'
        this.response = response
    }

    /**
     * Returns the status code from the Response instance.
     * @returns {string} The response status code
     */
    get responseStatus() {
        return this.response.status
    }

    /**
     * Returns the response message from the Response instance.
     * @returns {string} The response message
     */
    get responseMessage() {
        return this.response.statusText
    }

    /**
     * Overwrites the default toString method to return the response status and message.
     * @returns {string}
     */
    toString() {
        return `${this.responseStatus} | ${this.responseMessage}`
    }
}



// WEBPACK FOOTER //
// ./scripts/api/util/AjaxError.js